import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDecorationDetail } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
import { fetchListByType } from '@/api/PMS/dic/dic';
import chargeConfirm from '@/views/PMS/customerService/houseDeliveryManage/decorationRegistration/chargeConfirm';
export default {
  components: {
    chargeConfirm: chargeConfirm
  },
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      loading: false,
      list: [],
      multipleSelection: [],
      childData: {},
      options: [],
      payTypeOption: [],
      title: '',
      dialogFormVisible: false,
      rules: {
        beginDate: [{
          required: true,
          message: '请选择装修开始时间',
          trigger: 'change'
        }],
        expectEndDate: [{
          required: true,
          message: '请选择装修拟结束时间',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          message: '请输入实收金额',
          trigger: 'change'
        }, {
          required: true,
          message: '请输入实收金额',
          trigger: 'blur'
        }],
        receiptDate: [{
          required: true,
          message: '请选择收款日期',
          trigger: 'change'
        }],
        paymentMethod: [{
          required: true,
          message: '请选择收款日期',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    totalMoney: function totalMoney() {
      var total = 0;
      this.list.forEach(function (item) {
        total += parseFloat(item.amount);
      });
      return total;
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.loadPayTypeOption();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDecorationDetail(queryData).then(function (response) {
          _this.childData = response.data.data;

          if (_this.childData.decorateStandardInfoVos) {
            _this.list = _this.childData.decorateStandardInfoVos;
          }
        });
      } else {
        this.childData = {};
      }
    },
    handleMoneyChange: function handleMoneyChange(val) {
      var change = val - this.totalMoney;
      this.$set(this.childData, 'change', change);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBeginDate: function handleBeginDate(val) {
      if (val && this.childData.expectEndDate) {
        var endTime = new Date(this.childData.expectEndDate).getTime();
        var startTime = new Date(val).getTime();

        if (endTime < startTime) {
          this.$message.error('装修开始时间不能晚于装修结束时间');
          this.$set(this.childData, 'beginDate', '');
          return;
        }
      } // this.list.forEach(item => {
      //   item.beginDate = val
      // })

    },
    loadPayTypeOption: function loadPayTypeOption() {
      var _this2 = this;

      fetchListByType('pay_type').then(function (r) {
        _this2.payTypeOption = r.data.data;
      });
    },
    handleEndDate: function handleEndDate(val) {
      if (val && this.childData.beginDate) {
        var startTime = new Date(this.childData.beginDate).getTime();
        var endTime = new Date(val).getTime();

        if (endTime < startTime) {
          this.$message.error('装修结束时间不能早于装修开始时间');
          this.$set(this.childData, 'expectEndDate', '');
          return;
        }
      } // this.list.forEach(item => {
      //   item.expectEndDate = val
      // })

    },
    handlePaymentMethodSelect: function handlePaymentMethodSelect(val) {
      if (val) {
        var payType = this.payTypeOption.find(function (item) {
          return item.dicValue === val;
        });
        this.$set(this.childData, 'paymentMethodName', payType.dicName);
      } else {
        this.$set(this.childData, 'paymentMethodName', '');
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          for (var i = 0; i < _this3.list.length; i++) {
            if (_this3.list[i].chargeMathName === '每次单独输入' && !_this3.list[i].amount) {
              _this3.$message.error('请输入' + _this3.list[i].chargeStandardName + '的金额');

              return;
            }
          }

          _this3.childData.collectedAmount = _this3.totalMoney;

          if (_this3.childData.amount < _this3.childData.collectedAmount) {
            _this3.$message.error('实收金额不能少于应收金额');

            return;
          }

          var chargeObj = {
            paymentMethodName: _this3.childData.paymentMethodName,
            amount: _this3.childData.amount
          };

          if (_this3.childData.paymentMethodName) {
            _this3.$set(_this3.childData, 'chargeTypeList', [chargeObj]);
          } else {
            _this3.$set(_this3.childData, 'chargeTypeList', []);
          }

          _this3.childData.decorateStandardInfoVos = _this3.list;
          _this3.title = '收费信息确认';
          _this3.dialogFormVisible = true;
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle(state) {
      if (state === 'confirm') this.$emit('handCancle');
      this.dialogFormVisible = false;
    },
    handleCancle: function handleCancle() {
      this.$emit('handCancle');
    }
  }
};